




















































import {
  Component,
  Mixins,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bRow from 'bootstrap-vue/es/components/layout/row';

import PalettePanel from './PalettePanel';

@Component({
  components: {
    FontAwesomeIcon,

    bButton,
    bCol,
    bRow,
  },
})
export default class MobileButtonPalettePanel extends Mixins(PalettePanel) {
  public readonly faAngleRight = faAngleRight;

  get optionValues() {
    return this.value.option.values;
  }

  public showMobilePaletteModel() {
    this.$root.$emit('show::fullscreen::modal', 'mobile-palette-modal', {
      option: this.value.option,
      value: this.value.value,
      optionVariants: this.optionVariants,
      valueVariants: this.valueVariants,
    });
  }
}

